// import { useMediaQuery } from '@mantine/hooks'

// export const useIsDarkMode = () => useMediaQuery('(prefers-color-scheme: dark)')
// TODO: for initial release light-mode
export const useIsDarkMode = () => false
